<script lang="ts">
  import UInteractive from '$lib/components/UInteractive.svelte';
  import type { UPracticeData } from 'shared/definitions/progress-data';
  import type { ClientUserStore } from 'shared/src';
  import { createEventDispatcher } from 'svelte';
  export let clientUserStore: ClientUserStore;

  export let options: any = {
    clef: 'bass',
    drill: true,
    skills: ['bass_low_legers', 'bass_high_legers', 'bass_lines', 'bass_spaces'],
    maxQuestions: 15,
  };
  export let name = 'NoteID';

  interface $$Events {
    contentEnded: UPracticeData[];
    contentError: any;
    timeSpent: number;
  }
  const dispatch = createEventDispatcher<$$Events>();
</script>

<UInteractive
  {name}
  {options}
  {clientUserStore}
  on:gameOver={(data) => {
    // @ts-ignore -- data is in fact a CustomEvent<UPracticeData>, this is an error in
    // svelte-language-tools which I need to report.
    dispatch('contentEnded', data.detail);
  }}
  on:error={(err) => dispatch('contentError', err)}
  on:timeSpent
/>
